import { Table, TableBody, TableContainer } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { formatDate } from '../../../utils/format/date'
import { sortObjectsArray } from '../../../utils/functions/common'
import DialogInfo from '../../UI/DialogInfo'
import SupplierAgreementGroupRow from './SupplierAgreementGroupRow'
import SupplierAgreementTableHeader from './SupplierAgreementTableHeader'
import SupplierAgreementTotalsRow from './SupplierAgreementTotalsRow'

export default function SupplierAgreementDialog({ agreement, opened, onClose }) {
  const [coopGroups, setCoopGroups] = useState([])
  const [columns, setColumns] = useState([])

  useEffect(() => {
    const sortedGroups = sortObjectsArray([...agreement.coopGroups], 'name')
    const sortedColumns = agreement.columns ? sortObjectsArray([...agreement.columns], 'position') : []
    setCoopGroups(sortedGroups)
    setColumns(sortedColumns)
  }, [agreement])

  const useDynamicColumns = columns.length > 0

  return (
    <DialogInfo
      title="Accord"
      subtitle={`mise à jour ${formatDate(agreement.annex.creationDate)}`}
      open={opened}
      onClose={onClose}
    >
      <TableContainer style={{ paddingBottom: '50px' }}>
        <Table>
          <SupplierAgreementTableHeader useDynamicColumns={useDynamicColumns} columns={columns} />
          <TableBody>
            {coopGroups?.map((coopGroup) => (
              <SupplierAgreementGroupRow
                key={coopGroup.id}
                coopGroup={coopGroup}
                columns={columns}
                useDynamicColumns={useDynamicColumns}
              />
            ))}
            {coopGroups?.length > 0 && (
              <SupplierAgreementTotalsRow
                coopGroups={coopGroups}
                columns={columns}
                useDynamicColumns={useDynamicColumns}
              />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </DialogInfo>
  )
}
